import React from 'react'
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';



export default function Sidebar() {

  const { t } = useTranslation();

  return (
    <div className='sidebar'>
      <div className='sidebar-menu'>
        <ul>
          <li>
            <NavLink end to={'/restaurant/table-management/table/1'}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.5 19.9V4.1C10.5 2.6 9.86 2 8.27 2H4.23C2.64 2 2 2.6 2 4.1V19.9C2 21.4 2.64 22 4.23 22H8.27C9.86 22 10.5 21.4 10.5 19.9Z" stroke="#171717" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M22 10.9V4.1C22 2.6 21.36 2 19.77 2H15.73C14.14 2 13.5 2.6 13.5 4.1V10.9C13.5 12.4 14.14 13 15.73 13H19.77C21.36 13 22 12.4 22 10.9Z" stroke="#171717" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M22 19.9V18.1C22 16.6 21.36 16 19.77 16H15.73C14.14 16 13.5 16.6 13.5 18.1V19.9C13.5 21.4 14.14 22 15.73 22H19.77C21.36 22 22 21.4 22 19.9Z" stroke="#171717" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>

              <span>{t("restaurant.table_management.label_table")}</span>
            </NavLink>
          </li>
          <li>
            <NavLink end to={'/restaurant/table-management/reservations/list/1'}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" stroke="#1A1A1A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M2.03003 8.5H22" stroke="#1A1A1A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M2.03003 15.5H22" stroke="#1A1A1A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8.51001 21.9898V2.00977" stroke="#171717" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M15.51 21.9898V2.00977" stroke="#171717" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>

              <span>{t("restaurant.table_management.label_reservations")}</span>
            </NavLink>
          </li>
        </ul>
      </div>
    </div>
  )
}
